module.exports = __webpack_public_path__ + "static/media/Project2_Fig17.87bf2af3.png";